<template>
  <v-container fluid class="wizard-wrapper babyblue sites">
    <v-layout row wrap align-center>
      <v-flex xs12>
        <div class="title my-4 text-center">Choose the site that is right for you</div>
        <div class="v-list-wrapper">
          <v-list two-line class="babyblue">
            <template v-for="(item, index) in sites">
              <v-subheader v-if="item.header" :key="item.header">{{ item.header }}</v-subheader>

              <v-divider v-else-if="item.divider" :inset="item.inset" :key="index"></v-divider>

              <v-list-tile v-else :key="item.title" avatar>
                <v-layout column>
                  <v-flex xs12 sm3>
                    <img :src="item.avatar" />
                  </v-flex>

                  <v-flex xs12 sm9>
                    <v-list-tile-content>
                      <v-list-tile-sub-title v-html="item.subtitle"></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-flex>
                </v-layout>
              </v-list-tile>
            </template>
          </v-list>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "EtSites"
};
</script>

<style>
.v-list-wrapper {
  width: 900px;
  max-width: 100%;
  margin: 0 auto;
  padding: 0 15px;
}

.sites .v-list .v-list__tile--avatar {
	align-items: center;
}

.sites .v-list .v-list__tile--avatar img {
	width: 200px;
	margin: 0 auto;
	max-width: 100%;
}

.sites .v-list .v-list__tile__sub-title {
	color: #000;
	font-weight: normal;
	font-size: 16px;
}

.v-list .v-list__tile__content {
	position: relative;
	overflow: visible;
}

.v-list-wrapper .v-list > div:first-child .v-list__tile__content::after {
	content: '';
	display: none;
	position: absolute;
	left: 15px;
	bottom: 0;
	width: calc(100% - 30px);
	height: 1px;
	background: #000;
}

@media screen and (min-width:600px) {
	.sites .v-list .v-list__tile--avatar img {
		margin: 0;
		padding-right: 30px;
	}

	.v-list .v-list__tile__content {
		/* min-height: 120px; */
	}

	.v-list-wrapper .v-list > div:first-child .v-list__tile__content::after {
		display: block;
	}
}
@media screen and (min-width: 1264px) {
  .v-list-wrapper {
    width: 1185px;
  }

	.sites .v-list .v-list__tile__sub-title {
		font-size: 20px;
	}

	.sites .v-list .v-list__tile--avatar img {
		width: 300px;
		margin: 0;
		padding-right: 40px;
	}

	.v-list-wrapper .v-list > div:first-child {
		padding-bottom: 20px;
	}

	.v-list-wrapper .v-list > div:last-child {
		padding-top: 20px;
	}

	.v-list-wrapper .v-list > div:first-child .v-list__tile__content::after {
		left: -150px;
		bottom: -20px;
	}
}
</style>
